import React from 'react';

import { useDisclosure } from '@chakra-ui/react';

import { EnvironmentIcon } from 'components/Icons';
import { BlueprintDetailCard } from 'containers/PolicyHub/Blueprints/Components/Blueprint/Details/Cards/BlueprintDetailCard';
import { ManagedEnvironment } from 'containers/PolicyHub/Blueprints/Components/Blueprint/Details/ManagedEnvironments';

export const Environments: React.FC = () => {
  const { isOpen, onClose, onOpen } = useDisclosure();
  return (
    <>
      <BlueprintDetailCard
        icon={<EnvironmentIcon />}
        label="Environments"
        onClick={() => onOpen()}
      />
      {isOpen && <ManagedEnvironment isOpen={isOpen} onClose={onClose} />}
    </>
  );
};
